var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForsamlingshus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#021e3a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.29,6.99,7.981,2.647a.3.3,0,0,0-.372,0L2.3,6.99a.172.172,0,0,0,.108.3H3.684V12.81a.2.2,0,0,0,.2.2H5.866a.2.2,0,0,0,.2-.2V9.527a.2.2,0,0,1,.2-.2H9.1a.2.2,0,0,1,.2.2V12.81a.2.2,0,0,0,.2.2h1.983a.2.2,0,0,0,.2-.2V7.3h1.5A.172.172,0,0,0,13.29,6.99ZM7.8,6.732a.7.7,0,1,1,.7-.7A.7.7,0,0,1,7.8,6.732Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForsamlingshus);
export default __webpack_public_path__ + "static/media/FORSAMLINGSHUS.d1cc57bdf2c8e15ed3937041d2e5cef1.svg";
export { ForwardRef as ReactComponent };